import React from 'react'
import { MDBFooter, MDBContainer, MDBRow, MDBCol, MDBIcon } from 'mdb-react-ui-kit';
import {ContactUs} from "./ContactUs"

const site_style = {
    backgroundColor:"ivory"
}

const contact = () => {

    return (
        <div>
            <ContactUs/>
            <hr style={{color:"lightgrey"}}/>
            <Portfolio_Footer/>
        </div>
    )
}

function Portfolio_Footer(){
    return(
        <MDBFooter bgColor='dark' className='text-center text-lg-start text-muted'>
      <section className='d-flex justify-content-center justify-content-lg-between p-4 border-bottom'>

        Melden Sie sich bei mir, wenn Ihnen mein Portfolio gefällt.
        
      </section>

      <section className=''>
        <MDBContainer className='text-center text-md-start mt-5'>
          <MDBRow className='mt-3'>
            <MDBCol md="3" lg="4" xl="3" className='mx-auto mb-4'>
              <h6 className='text-uppercase fw-bold mb-4'>
                <MDBIcon icon="gem" className="me-2" />
                Portfolio Adrian Dröse
              </h6>
              <p>
                Kontaktieren Sie mich unter der angegebenen E-Mail oder per Telefon. Besuchen Sie bei Interesse außerdem meine Github-Seite, wo Sie Programme finden können, die ich im Laufe meines Studiums geschrieben habe.
              </p>
              
            </MDBCol>

            <MDBCol md="4" lg="3" xl="3" className='mx-auto mb-md-0 mb-4'>
              <h6 className='text-uppercase fw-bold mb-4'>Kontakt</h6>
              <p>
                <MDBIcon icon="envelope" className="me-2" />
                droese.websites@gmail.com
              </p>
              <p>
                <MDBIcon icon="envelope" className="me-2" />
                 adrian.droese@web.de
              </p>
              <p>
                {/*<MDBIcon icon="github" className="me-2" /> https://github.com/businesswebsites*/}
                <a className="me-2 text-reset fw-bold" href='https://github.com/businesswebsites' >Github</a>
              </p>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      </section>

      <div className='text-center p-4' style={{ backgroundColor: 'rgba(0, 0, 0, 0.05)' }}>
        © 2022 Copyright:
        <a className='text-reset fw-bold' href='https://businesswebsites.github.io/portfolio/'>
        https://businesswebsites.github.io/portfolio/
        </a>
      </div>
    </MDBFooter>
    )
}


export default contact